import { apiClient } from "./apiClient";

export interface ApiKey {
  id: string;
  name: string;
  scopes: string[];
  created_at: string | null;
  last_used_at: string | null;
  expires_at: string | null;
}

export interface CreateApiKeyInput {
  name: string;
  scopes: string[];
  expires_in_days?: number;
}

export interface CreatedApiKey extends ApiKey {
  /** The plain text token. Returned ONCE on creation; cannot be retrieved later. */
  plain_token: string;
}

interface Wrapped<T> {
  data: T;
  meta?: Record<string, unknown>;
}

export async function listApiKeys(): Promise<ApiKey[]> {
  const res = await apiClient.get<Wrapped<ApiKey[]>>("/v1/api-keys");
  return res.data;
}

export async function createApiKey(input: CreateApiKeyInput): Promise<CreatedApiKey> {
  const res = await apiClient.post<Wrapped<CreatedApiKey>>("/v1/api-keys", input);
  return res.data;
}

export async function revokeApiKey(id: string): Promise<void> {
  await apiClient.delete(`/v1/api-keys/${id}`);
}

export const ALLOWED_SCOPES = [
  "templates.read",
  "templates.write",
  "templates.delete",
  "webhooks.read",
  "webhooks.write",
  "render.execute",
] as const;
